module.exports = require('./lib/client');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-socketio/client.js
// module id = 560
// module chunks = 2